import React, { FC } from 'react'
import { PatternFormat } from 'react-number-format'
import { NumberFormatValues } from 'react-number-format/types/types'
import { BtEncryptedInput, BtEncryptedInputProps } from './BtEncryptedInput'

interface BtTaxIdInputProps extends BtEncryptedInputProps {}

export const BtTaxIdInput: FC<BtTaxIdInputProps> = ({
  size = 'large',
  value,
  label,
  required,
  validate,
  validationError,
  onChangeText,
  testID,
}) => {
  const handleValueChange = (formatValues: NumberFormatValues) => {
    if (onChangeText) {
      onChangeText(formatValues.value)
    }
  }

  const handleValidate = (text: string) => {
    if (validationError) {
      return value?.length !== 9 ? validationError : ''
    } else {
      return validate && validate(text)
    }
  }

  return (
    <PatternFormat
      format="#########"
      placeholder="000000000"
      size={size}
      label={label}
      value={value}
      required={required}
      customInput={BtEncryptedInput}
      keyboardType="number-pad"
      allowEmptyFormatting={false}
      validate={handleValidate}
      onValueChange={handleValueChange}
      valueIsNumericString
      testID={testID}
    />
  )
}
